import React from 'react'
import api, { METHODS } from './api'
import Report from '../common/types/api/report'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'
import { MailJobSettings, Recipient } from '../common/types/form'

interface ResponseType {
    success: boolean
    error: string
    title?:string
}

export default async function sendManualReport(
    uid: string,
    referenceDate: Date,
    timespan: string,
    recipientGroups: Recipient[]
): Promise<{ success: boolean; error: string }> {
    try {
        const res = await api<ResponseType>(
            `manualReport/${uid}`,
            METHODS.POST,
            JSON.stringify({
                recipients: recipientGroups,
                span: timespan,
                dateRef: referenceDate ? referenceDate.getTime() : null
            } as MailJobSettings)
        )
        if (!res.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to run a manual report: ')}>{'unknown error'}</Notification>,
                20
            )

            console.error(res)
        } else {
            GlobalNotification.success(<Notification title={i18n('Reported successfully!')} />, 20)
        }

        return res
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to to run a manual report:')}>{error}</Notification>,
            20
        )

        console.error(error)

        return null
    }
}
